jQuery(function() {
    jQuery(".js-load-more-posts").on("click", function(e) {
        console.log("testing");
        e.preventDefault();
        jQuery( this ).prop( "disabled", true );
        //console.log("get data");
        var paged = jQuery(".js-load-more-posts").attr('data-paged');
        var posts_per_page = parseInt(jQuery(this).attr('data-posts-per-page'));
        var lang = "";
        var data_lang = jQuery(".js-load-more-posts").attr("data-lang");
        if (typeof data_lang !== typeof undefined && data_lang !== false) {
            lang = jQuery(this).attr('data-lang');
        }
        var url = window.location.origin + "/wp-content/themes/franchise/load-latest-posts-json.php";
        if(lang != ""){
            url = window.location.origin + "/es/wp-content/themes/franchise/load-latest-posts-json.php";
        }
        //console.log(url);
        $.ajax({
            //url: "http://freeway.test/api/knowledge/get-paged-posts.php",
            url: url,
            data: "paged=" + paged+"&posts_per_page=" + posts_per_page,
            type: "GET",
            //dataType: "jsonp", 
            success: function(data) {
                var obj = jQuery.parseJSON(data);
                //console.log(data);

                if (obj.content.length > 0) {
                    var max_num_paged = parseInt(obj.max_num_pages);

                    paged = parseInt(paged) + 1;
 
                    if (paged > max_num_paged) {
                        jQuery(".js-load-more-posts").hide();
                    }
                    jQuery(".js-load-more-posts").attr('data-paged', paged);
                    jQuery("div.c-article-teaser div.c-article-teaser__item:last").after(obj.content);
                    jQuery(".js-load-more-posts").prop( "disabled", false );
                    
                }
                //console.log(data);
                //console.log("get data");
            }
        });
    })
})